import { EvoluaApiError } from "@evolua/api-client";

type ForbiddenHandler = () => void;

let onForbidden: ForbiddenHandler | null = null;

/** Registrado dentro do Router — navega para /acesso-negado em 403. */
export function bindForbiddenHandler(handler: ForbiddenHandler | null): void {
  onForbidden = handler;
}

export function handleGlobalApiError(error: unknown): void {
  if (error instanceof EvoluaApiError && error.status === 403) {
    onForbidden?.();
  }
}

export function isForbiddenError(error: unknown): boolean {
  return error instanceof EvoluaApiError && error.status === 403;
}
